// extracted by mini-css-extract-plugin
export default {"contenedor":"Carrusel_contenedor__0AkyZ","img":"Carrusel_img__T2CES","boton":"Carrusel_boton__C-sTP"};